var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kv-ve-spacer",class:{ 'is-selected': _vm.selected }},[_c('div',{staticClass:"kv-ve-spacer__inner",style:({ height: _vm.heightPx })})])
}
var staticRenderFns = []

export { render, staticRenderFns }